


export const INCREASE_COUNT= 'INCREASE_COUNT';
export const ADD_ITEM= 'ADD_ITEM';
export const DECREASE_COUNT= 'DECREASE_COUNT';
export const DELETE_ITEM= 'DELETE_ITEM';
export const ADD_SHIPPING_ADDRESS= 'ADD_SHIPPING_ADDRESS';
export const DELETE_CART_ITEM= 'DELETE_CART_ITEM';
